<template>
  <div class="global_forum_portal" :class="{ 'dark': dark }">
    <v-container class="pa-0" id="forum_portal_table">
      <v-card class="pa-4 elevation-1" id="forum_portal_card">
        <v-card-title class="d-flex justify-space-between" id="forum_portal_title">
          <h3 class="mb-0">Fóruns</h3>
        </v-card-title>

        <!-- <v-text-field
          v-model="search"
          label="Buscar Fórum"
          prepend-inner-icon="mdi-magnify"
          outlined
          dense
          class="mt-4"
        /> -->

        <!-- Tabela para desktop -->
        <v-data-table
          v-if="!isMobile"
          :headers="headers"
          :items="forums"
          :items-per-page="15"
          :search="search"
          :loading="loading"
          
          class="elevation-1 mt-4 table_forum"
          @click:row="goToForum"
          id="forum_portal_table_desktop"
        >
          <template v-slot:item="{ item }">
            <tr class="forum_portal_table_row_tr">
              <td>{{ item.title }}</td>
              <td>{{ item.description }}</td>
              <td>{{ formatDate(item.dateInsert) }}</td>
              <td>{{ item.userName }}</td>
              <td>
                <v-chip color="blue lighten-4" text-color="primary" small>
                  {{ item.commentsQty }} respostas
                </v-chip>
              </td>
              <td>
                <v-btn color="primary" dark @click="goToForum(item)">Ver Fórum</v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <v-alert type="info" color="lighten-5" border="left" colored-border style="margin: 1%;background-color: #f3f3f3 !important;' color: black !important;">
              Nenhum fórum encontrado.
            </v-alert>
          </template>
        </v-data-table>

        <!-- Tabela simplificada para mobile -->
        <v-data-table
          v-else
          :headers="headersMobile"
          :items="forums"
          :items-per-page="15"
          :search="search"
          :loading="loading"
          class="elevation-1 mt-4 table_forum_mobile"
          id="forum_portal_table_mobile"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>{{ item.title }}</td>
              <td>
                <v-btn color="primary" dark @click="goToForum(item)">Ver Fórum</v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <v-alert type="info" color="blue lighten-5" border="left" colored-border>
              Nenhum fórum encontrado.
            </v-alert>
          </template>
        </v-data-table>
      </v-card>
    </v-container>
  </div>
</template>

<script>
import api from '@/utils/portal/forum.js'
import { mapState } from 'vuex';
import { toast } from 'vue3-toastify';

export default {
  data() {
    return {
      search: '',
      loading: false,
      forums: [],
      headers: [
        {
          title: 'Título',
          key: 'title',
          sortable: false,
          align: 'center',
        },
        {
          title: 'Descrição',
          key: 'description',
          sortable: false,
          align: 'center',
        },
        {
          title: 'Data de Criação',
          key: 'dateInsert',
          sortable: false,
          align: 'center',
        },
        {
          title: 'Autor',
          key: 'userName',
          sortable: false,
          align: 'center',
        },
        {
          title: 'Respostas',
          key: 'commentsQty',
          sortable: false,
          align: 'center',
        },
        {
          title: 'Opções',
          key: 'id',
          sortable: false,
          align: 'center',
        },
      ],
      headersMobile: [
        {
          title: 'Título',
          key: 'title',
          sortable: false,
          align: 'center',
        },
        {
          title: 'Opções',
          key: 'id',
          sortable: false,
          align: 'center',
        },
      ],
      isMobile: false,
    }
  },
  computed: {
    ...mapState(['dark'])
  },
  methods: {
    formatDate(date) {
      const d = new Date(date)
      return d.toLocaleDateString('pt-BR')
    },
    async fetchForums() {
      this.loading = true
      try {
        const response = await api.getDataForum(this.$store.state.token)
        this.forums = response;
      } catch (e) {
        toast.error('Erro ao carregar fóruns')
        console.error('Erro ao carregar fóruns', e)
      } finally {
        this.loading = false
      }
    },
    goToForum(forum) {
      this.$router.push(`/aluno/forum/${forum.id}`)
    },
    newForum() {
      // abrir modal ou ir para página de criação
    },
    checkMobile() {
      this.isMobile = window.innerWidth <= 600
    }
  },
  mounted() {
    this.fetchForums()
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.checkMobile)
  }
}
</script>
<style>
@import './css/forum.css';
</style>